/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SearchCustomerResponse { 
    birthDate?: string;
    blocked?: SearchCustomerResponse.BlockedEnum;
    code?: string;
    creationDate?: Date;
    email?: string;
    firstName?: string;
    id?: number;
    lastName?: string;
    pep?: boolean;
    watched?: boolean;
}
export namespace SearchCustomerResponse {
    export type BlockedEnum = 'Active' | 'Unactive' | 'Blocked' | 'Unblocked';
    export const BlockedEnum = {
        Active: 'Active' as BlockedEnum,
        Unactive: 'Unactive' as BlockedEnum,
        Blocked: 'Blocked' as BlockedEnum,
        Unblocked: 'Unblocked' as BlockedEnum
    };
}
